import { z } from "zod"

export const powurOsAdderCategorySchema = z.object({
  id: z.number().int(),
  name: z.string(),
  allowMultiples: z.boolean(),
})
export type PowurOsAdderCategory = z.infer<typeof powurOsAdderCategorySchema>

export const powurOsAdderLenderCategorySchema = z.object({
  id: z.number().int(),
  lenderId: z.number().int(),
  lenderName: z.string(),
  name: z.string(),
})
export type PowurOsAdderLenderCategory = z.infer<
  typeof powurOsAdderLenderCategorySchema
>
